import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../../../shared/ui/loading/LoadingScreen";

export const AuthCallback: React.FC = () => {
  const { initSession, status, user } = useAuth();
  const navigate = useNavigate();
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      // Si déjà authentifié, on redirige directement
      if (status === "authenticated" && user) {
        const returnTo = sessionStorage.getItem("returnTo") || "/";
        sessionStorage.removeItem("returnTo");
        navigate(returnTo, { replace: true });
        return;
      }

      // Sinon, on initialise la session (appel à /me)
      await initSession();
      setProcessed(true);
    };

    handleCallback();
  }, [initSession, status, user, navigate]);

  // Après avoir appelé initSession, on redirige
  useEffect(() => {
    if (processed && status !== "initializing") {
      const returnTo = sessionStorage.getItem("returnTo") || "/";
      sessionStorage.removeItem("returnTo");
      navigate(returnTo, { replace: true });
    }
  }, [processed, status, navigate]);

  return <LoadingScreen text="Connexion en cours..." />;
};